import React from "react";
import gsap from 'gsap'
import { TweenMax, TimelineMax } from "gsap"
import ScrollToPlugin from "gsap/ScrollToPlugin";
// import ScrollToPlugin from '../../node_modules/gsap/ScrollToPlugin';

gsap.registerPlugin(TweenMax, TimelineMax, ScrollToPlugin);
const plugins = [ScrollToPlugin];

let previousPageId;
let nextPageId;
export const exitFunction = (node, e) => {
  // console.log('exited');
  let tl = new TimelineMax();
  let body = document.body;
  let heroImageCenter = node.querySelector('div.image-wrap-center');
  let heroImageLeft = node.querySelector('a.image-wrap-left');
  let heroImageRight = node.querySelector('a.image-wrap-right');
  let heroWidth = heroImageCenter.clientWidth + 30;
  previousPageId = node.querySelector('div#content').getAttribute('data-id');
  nextPageId = e.target.getAttribute('data-id');
  let xVal;
  if(parseInt(previousPageId) > parseInt(nextPageId)) {
    xVal = "100%";
  } else {
    xVal = "-100%";
  }
  tl.set(body, {pointerEvents: "none"})
  .to(heroImageCenter, .25, {scale: .8, zIndex: 50, position: "relative"})
  .to(heroImageLeft, .25, {x: "-60px"}, "-=.25")
  .to(heroImageRight, .25, {x: "60px"}, "-=.25")
  .to(heroImageCenter, .4, {x: xVal}, "ease: Power2.easeIn")
}

export const entryFunction =(node, e) => {
  let body = document.body;
  let heroImage2 = node.querySelector('div.image-wrap-center');
  let heroImageLeft2 = node.querySelector('a.image-wrap-left');
  let heroImageRight2 = node.querySelector('a.image-wrap-right');
  let tl2 = new TimelineMax();
  let xVal;
  if(parseInt(previousPageId) > parseInt(nextPageId)) {
    xVal = "-100%";
  } else {
    xVal = "100%";
  }

  tl2.set(heroImage2, {x: xVal, scale: .8, opacity: 1})
  .set(heroImageRight2, {x: "60px"})
  .set(heroImageLeft2, {x: "-60px"})
  .to(heroImage2, .8, {x: "0%"}, "ease: Power2.easeOut")
  .to(heroImage2, .25, {scale: 1})
  .to(heroImageLeft2, .25, {x: "0"}, "-=.25")
  .to(heroImageRight2, .25, {x: "0"}, "-=.25")
  .set(body, {pointerEvents: "auto"})
}

export const exitMobileFunction = (node, e) => {
  let tlMobile = new TimelineMax();
  let tlMobileOther = new TimelineMax();
  const targetItem = e.target;
  targetItem.parentNode.classList.add('target');
  const scrollNav = document.querySelector('#slider-nav');
  const sliderItems = document.querySelectorAll('.slider-nav-card:not(.target)');
  for(let x = 0; x < sliderItems.length; x++) {
    // tlMobileOther.set(sliderItems[x], {opacity: 0});
  }

  tlMobile.to(scrollNav, .5, {scrollTo: targetItem})
  .to(document.body, .25, {opacity: 0}, "-=.15")

}

export const entryMobileFunction = (node, e) => {
  let tlMobile2 = new TimelineMax();
  let heroImage3 = node.querySelector('div.image-wrap-center');
  let content = node.querySelector('div#content');

  tlMobile2
  .set(content, {y: 500, opacity: 0})
  .to(document.body, .25, {opacity: 1})
  .to(content, .45, {y: 0, opacity: 1})
}






















